<template>
  <v-layout column class="inner-pages">
    <Header toolbarHeight="70px" header-height="60px"/>

    <v-flex px-1 class="sfh-login-form background-image scrollbar scroll-style-15" :style="styleObj">

      <v-tabs
        v-model="tabs"
        fixed-tabs
        color="transparent"
        class="tab-container"
      >
        <v-tabs-slider></v-tabs-slider>
        <v-tab href="#tab-1" :class="tabs === 'tab-1' ? 'border': ''" style="margin: 0">
          <h2 class="tab-name">Support</h2>
        </v-tab>

        <v-tab href="#tab-2" :class="tabs === 'tab-2' ? 'border': ''">
          <h2 class="tab-name">Delete Account</h2>
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tabs" class="transparent">
        <v-tab-item
          value="tab-1"
        >
          <p class="pa-4">Your success is very important to each of us at Cogneti. Give us feedback, and we'll listen. Request support,
            and we'll contact you.</p>
          <v-container grid-list-xl fluid>
            <v-layout  layout justify-center >
              <v-flex xs12>
                <v-layout row wrap>

                  <v-flex pt-0 xs12>
                    <v-text-field
                      prepend-icon="phone"
                      label="Phone number"
                      type="text"
                      v-validate="'required'"
                      :error-messages="errors.collect('slot1.phone')"
                      v-model="phone"
                      :hide-details="true"
                      data-vv-name="slot1.phone"
                      data-vv-validate-on="blur"
                      data-vv-scope="slot1"
                    ></v-text-field>

                    <v-switch
                      v-model="isPhone"
                      label="Request return telephone contact"
                      color="success"
                      value="1"
                      class="mt-0"
                      hide-details
                    ></v-switch>

                    <v-text-field
                      prepend-icon="mail"
                      label="Email"
                      class="mt-3"
                      readonly
                      :hide-details="true"
                      v-model="user.email"
                    ></v-text-field>

                    <v-switch
                      v-model="isEmail"
                      label="Request return email contact"
                      color="success"
                      value="1"
                      class="mt-0"
                      :hide-details="true"
                    ></v-switch>

                    <v-textarea color="teal"  :counter="200" maxlength="200" v-validate="'required'"
                                data-vv-name="slot1.feedbackText"
                                rows="4"
                                class="support-textarea"
                                data-vv-validate-on="blur"
                                placeholder=""
                                data-vv-scope="slot1"
                                :error-messages="errors.collect('slot1.feedbackText')" v-model="feedbackText"
                                label="Your request or comment"></v-textarea>
                  </v-flex>

                  <v-flex xs12>
                    <v-avatar
                      slot="activator"
                      size="80px"
                      :tile=true
                      color="primary"
                      v-if="imageData"
                    >
                      <img :src="imageData" alt="Screenshot">
                    </v-avatar>
                    <upload-button title="Attach screenshot" :selectedCallback="fileSelectedFunc">
                    </upload-button>
                  </v-flex>
                  <!--              <v-flex xs12 >-->
                  <!--                <vue-recaptcha-->
                  <!--                  ref="recaptcha"-->
                  <!--                  style="transform:scale(0.77);transform-origin:0 0"-->
                  <!--                  @verify="onVerify"-->
                  <!--                  @expired="onExpired"-->
                  <!--                  :sitekey="sitekey"></vue-recaptcha>-->
                  <!--                <div class="error&#45;&#45;text">{{ errors.first('slot1.recaptcha') }}</div>-->
                  <!--              </v-flex>-->

                  <v-flex xs12>
                    <v-btn block @click="sendMessage" :loading="loading" :disabled="isSendSuccess"
                           color="primary">Send</v-btn>
                  </v-flex>

                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </v-tab-item>
        <v-tab-item
          value="tab-2"
        >
          <div class="pa-4">
            Delete your account to remove all account and personal information.
            <div class="mt-5">
              Please confirm your login email address.
              <v-text-field
                prepend-icon="mail"
                label="Email"
                :hide-details="true"
                v-model="confirmEmail"
              ></v-text-field>
              <v-flex xs12 class="mt-5">
                <v-btn block @click="confirmDeleteDialog = true"
                       :disabled="confirmEmail !== user.email"
                       color="primary">Delete</v-btn>
              </v-flex>
            </div>
          </div>
        </v-tab-item>
      </v-tabs-items>

      <v-dialog
        v-model="confirmDeleteDialog"
        max-width="290"
      >
        <v-card>
          <v-card-title class="headline">Are you sure?</v-card-title>

          <v-card-text class="pt-2 pb-5">
            Once you delete your account, there is no going back. Please be certain.
          </v-card-text>

          <v-divider></v-divider>
          <v-card-actions>
            <v-btn
              flat
              @click="confirmDeleteDialog = false"
            >
              Cancel
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              color="error"
              flat
              @click="deleteAccount"
            >
              Delete
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-flex>
  </v-layout>



</template>

<script>
  import Vue from 'vue'
  import VueCroppie from 'vue-croppie'
  import VeeValidate from 'vee-validate'
  import VWidget from './widgets/VWidget'
  import UploadButton from './widgets/UploadButton'
  import VueRecaptcha from 'vue-recaptcha'
  import Header from '../layouts/Header'
  import { UAParser } from 'ua-parser-js'

  Vue.use(VeeValidate)
  Vue.use(VueCroppie)

  export default {
    name: 'ContactSupport',
    components: {Header, UploadButton, VWidget, VueRecaptcha},
    data: () => ({
      tabs: null,
      confirmEmail: '',
      confirmDeleteDialog: false,
      isSendSuccess: false,
      widgets: false,
      loading: false,
      imageData: '',
      screenShotFileName: '',
      feedbackText: '',
      phone: '',
      isPhone: false,
      email: '',
      isEmail: false,
      lastName: '',
      oldPassword: '',
      newPassword: '',
      disabled: false,
      apiUrl: process.env.API_URL,
      e1: true,
      e2: true,
      dialog: false,
      isCaptchaValidated: false,
      sitekey: '6LczvKcUAAAAAEEcXs4CEqSE2k6CHZECm21t9z-H',
      dictionary: {
        custom: {
          'slot1.phone': {
            required: () => 'Phone is required'
          },
          'slot1.feedbackText': {
            required: () => 'Comment should not be blank.'
          }
        }
      }
    }),
    computed: {
      user () {
        return this.$store.getters['user/getUserDetails']
      },
      styleObj () {
        // const height = this.$store.getters.getAppHeight
        return {
          // 'height': height + 'px!important',
          'padding-top': '0!important',
          'padding-left': '10px!important',
          'overflow': 'auto'
        }
      }
    },
    mounted () {
      this.$validator.localize('en', this.dictionary)
    },
    methods: {
      onVerify: function (response) {
        this.isCaptchaValidated = true
      },
      onExpired: function () {
        this.isCaptchaValidated = false
      },
      resetRecaptcha () {
        this.$refs.recaptcha.reset() // Direct call reset method
      },
      fileSelectedFunc: function (event) {
        let input = event.target
        if (input.files && input.files[0]) {
          let reader = new FileReader()
          reader.onload = (e) => {
            this.afterImageLoaded(input.files[0])
            this.imageData = e.target.result
          }
          reader.readAsDataURL(input.files[0])
        }
      },
      afterImageLoaded (imageData) {
        let data = new window.FormData()
        data.append('avatar', imageData)
        this.$http({
          url: `${this.apiUrl}/ws/userservice/user/${this.user.id}/feedback/attachment`,
          method: 'POST',
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          data
        }).then((res) => {
          this.screenShotFileName = res.data
        }, (err) => {
          this.$store.dispatch('apiError', {errorObj: err})
        })
      },
      sendMessage () {
        this.$validator.validateAll('slot1').then((result) => {
          if (result) {
            const { browser, cpu, device } = UAParser(navigator.userAgent)
            const userAgent = {...browser, ...cpu, ...device}

            console.log({...browser, ...cpu, ...device})
            // if (this.isCaptchaValidated === false) {
            //   this.errors.add({
            //     scope: 'slot1',
            //     field: 'recaptcha',
            //     msg: 'Please verify you are human'
            //   })
            //   return
            // }
            this.loading = true
            this.$http({
              url: `${this.apiUrl}/ws/userservice/user/feedback`,
              method: 'POST',
              data: {
                text: this.feedbackText,
                attachment: this.screenShotFileName,
                callbackTelephone: !!this.isPhone,
                callbackEmail: !!this.isEmail,
                telephone: this.phone,
                userId: this.user.id,
                client: 'php',
                courseId: process.env.GAME_ID,
                userAgent: {
                  name: userAgent.name || '',
                  version: userAgent.major || '',
                  vendor: userAgent.vendor || '',
                  model: userAgent.model || '',
                  type: userAgent.type || ''
                }
              }
            }).then((res) => {
              this.$store.commit('flashSuccess', 'Thanks for submitting your feedback.')
              this.loading = false
              this.isSendSuccess = true
              this.$router.push({name: 'Home'})
            }, (err) => {
              this.$store.dispatch('apiError', {errorObj: err, customMsg: 'Unable to process your request'})
              this.loading = false
            })
          } else {
            this.loading = false
            this.$store.commit('flashError', 'Please fix all errors.')
          }
        })
      },
      deleteAccount () {
        this.loading = true
        this.$http({
          url: `${this.apiUrl}/ws/playerservice/user`,
          method: 'DELETE',
          headers: {
            Authorization: 'Bearer ' + this.$auth.token()
          }
        }).then(() => {
          this.$store.commit('flashSuccess', 'Account deleted successfully.')
          this.loading = false
          this.$auth.logout({
            redirect: '/',
            makeRequest: false
          })
        }, (err) => {
          this.$store.dispatch('apiError', {errorObj: err, customMsg: 'Unable to process your request'})
          this.loading = false
        })
      }
    }
  }
</script>

<style scoped>
  .tab-container {
    margin-top: 50px;
  }
  .tab-name{
    padding-bottom: 13px;
    font-weight: 500;
    text-transform: capitalize;
  }
  .border {
    border-bottom: 3px solid #82b1ff;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/ContactSupport.vue